import React from 'react';
import {
  Button,
  // ButtonGroup,
  CssBaseline,
  Grid,
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell,
  withStyles,
} from '@material-ui/core';

import Topbar from '../components/Topbar';
import Footer from '../components/Footer';
import Container from '../components/Div/Container';
import MainTitle from '../components/Text/MainTitle';
import Preparing from '../components/Preparing';
// import KakaoMaps from './KakaoMaps';
import SubTitle from '../components/Text/SubTitle';

const styles = (theme) => ({
  message: {
    padding: theme.spacing(2, 0, 5),
    color: '#555',
    textAlign: 'justifyContent',
    '& p': {
      marginBottom: '1.2em',
    },
  },
  divLine: {
    width: '100%',
    height: '1px',
    margin: theme.spacing(7, 0),
    backgroundColor: 'rgba(0,0,0,0.1)',
  },
});

const StyledTitleCell = withStyles((theme) => ({
  root: {
    backgroundColor: '#237a9d',
    color: '#fff',
    fontSize: '1.4em',
    fontWeight: 'bold',
    textAlign: 'center',
  },
}))(TableCell);

const StyledTableCell = withStyles((theme) => ({
  root: {
    fontSize: '1.4em',
    backgroundColor: '#e9eef1',
    border: '2px solid #fff',
    // fontWeight: 'bold',
    textAlign: 'center',
  },
}))(TableCell);

class Venue extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      matches: window.matchMedia('(max-width:600px)').matches,
      tabValue: 0,
    };
  }

  componentDidMount() {}
  handleState(key, value) {
    this.setState({ [key]: value });
  }

  render() {
    const { tabValue } = this.state;
    return (
      <div>
        <CssBaseline />
        <Topbar MIdx={7} SIdx={0} />
        <Container>
          <Grid container justifyContent={'center'}>
            <Grid item xs={8}>
              <MainTitle>Venue</MainTitle>

              {/* <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                <ButtonGroup color="primary" fullWidth disableElevation style={{ width: '80%' }}>
                  <Button
                    variant={tabValue === 0 ? 'contained' : 'outlined'}
                    onClick={() => this.handleState('tabValue', 0)}
                    style={{ fontSize: 'large' }}
                  >
                    Grand Intercontinental Seoul Parnas
                  </Button>
                  <Button
                    variant={tabValue === 1 ? 'contained' : 'outlined'}
                    onClick={() => this.handleState('tabValue', 1)}
                    style={{ fontSize: 'large' }}
                  >
                    Floor Plan
                  </Button>
                </ButtonGroup>
              </div> */}

              {tabValue === 0 && (
                <Grid container>
                  <SubTitle>GRAND INTERCONTINENTAL SEOUL PARNAS</SubTitle>
                  <Grid container justifyContent="center">
                    <Grid container item xs={12} justifyContent="center">
                      {/* 전경 이미지와 KAKAO MAP */}
                      <Grid container justifyContent="center" style={{ height: 400, margin: '16px 0' }}>
                        <Grid item xs={7} container justifyContent="flex-start">
                          <img
                            src={`https://innon.s3.ap-northeast-2.amazonaws.com/PRS2022/info/venue_main_img.jpg`}
                            alt=""
                            style={{ width: '100%', maxWidth: 700, maxHeight: 400 }}
                          />
                        </Grid>
                        <Grid container item xs={5}>
                          {/* <KakaoMaps /> */}
                          <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3164.9591205575116!2d127.0608141!3d37.508882299999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xe1e3206ca296580a!2sGrand%20InterContinental%20Seoul%20Parnas!5e0!3m2!1sen!2skr!4v1660026660165!5m2!1sen!2skr"
                            allowFullScreen=""
                            referrerPolicy="no-referrer-when-downgrade"
                            loading="lazy"
                            style={{ width: '100%', border: 0 }}
                            title="map"
                          />
                        </Grid>
                      </Grid>

                      <TableContainer>
                        <Table>
                          <TableBody>
                            <TableRow>
                              <StyledTitleCell width={'30%'}>Address</StyledTitleCell>
                              <StyledTableCell width={'70%'}>(06164) 521, Teheran-ro, Gangnam-gu, Seoul, Korea</StyledTableCell>
                            </TableRow>
                            <TableRow>
                              <StyledTitleCell>TEL</StyledTitleCell>
                              <StyledTableCell>+82 2-555-5656</StyledTableCell>
                            </TableRow>
                            <TableRow>
                              <StyledTitleCell>FAX</StyledTitleCell>
                              <StyledTableCell>+82 2-559-7990</StyledTableCell>
                            </TableRow>
                            <TableRow>
                              <StyledTitleCell>E-mail</StyledTitleCell>
                              <StyledTableCell>
                                <a href={`mailto:grandic@parnas.co.kr`}>grandic@parnas.co.kr</a>
                              </StyledTableCell>
                            </TableRow>
                            <TableRow>
                              <StyledTitleCell>Web site</StyledTitleCell>
                              <StyledTableCell>
                                <Grid container>
                                  <Grid container justifyContent="center" item xs={6}>
                                    <Grid container item xs={10} sm={9} md={8} lg={7}>
                                      <Button
                                        size={'large'}
                                        color="primary"
                                        variant="contained"
                                        fullWidth
                                        style={{ color: '#fff' }}
                                        onClick={() => {
                                          window.open(`https://seoul.intercontinental.com/grandicparnas
                                                        `);
                                        }}
                                      >
                                        KOR
                                      </Button>
                                    </Grid>
                                  </Grid>
                                  <Grid item xs={6} container justifyContent="center">
                                    <Grid container item xs={10} sm={9} md={8} lg={7}>
                                      <Button
                                        size={'large'}
                                        color="primary"
                                        variant="contained"
                                        fullWidth
                                        style={{ color: '#fff' }}
                                        onClick={() => {
                                          window.open(`https://seoul.intercontinental.com/grandicparnas/eng/`);
                                        }}
                                      >
                                        ENG
                                      </Button>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </StyledTableCell>
                            </TableRow>
                            {/* <TableRow>
                              <StyledTitleCell>Location</StyledTitleCell>
                              <StyledTableCell>
                                <KakaoMaps />
                              </StyledTableCell>
                            </TableRow> */}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Grid>
                  </Grid>
                </Grid>
              )}

              {tabValue === 1 && (
                <Grid container justifyContent="center" style={{ paddingTop: 48 }}>
                  <Preparing />
                </Grid>
              )}
            </Grid>
          </Grid>
        </Container>
        <Footer />
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(Venue);
